import { TranslationNamespaces } from '~/lib/constants';
import { ProductCurrency, ProductItem, ProductSlots } from '../adapters/product-types';
import { useTranslation } from 'react-i18next';
import BasketItemContainer from '~/components/basket-summary/basket/basket-item-container';
import { P2GGrid, P2GText } from '@parcel2go/core-ui';
import ProductSummaryHeader from './product-summary-header';
import ProductItemLocations from '../locations/product-item-locations';
import { ProductItemParcels } from '../parcels/product-item-parcels';

type ProductSummaryProps = {
  item: ProductItem;
  currency: ProductCurrency;

  index: number; // Used mainly for data test IDs for specific items
  slots?: ProductSlots;
};

export function ProductSummary({ index, item, currency, slots }: ProductSummaryProps) {
  const { t } = useTranslation(TranslationNamespaces.COMPLETE);
  return (
    <BasketItemContainer
      title={<ProductSummaryHeader currency={currency} index={index} item={item} slots={slots} />}
      left={
        <P2GGrid container flexDirection="column" spacing={2}>
          <P2GGrid item>
            <ProductItemLocations productItem={item} />
          </P2GGrid>
          <P2GGrid item>
            <P2GText variant="subtitle2" colour="textSecondary" fontWeight="bold">
              {t('CONFIRM_PARCELS_TITLE', { defaultValue: 'Parcels' })}
            </P2GText>
          </P2GGrid>
          <P2GGrid item>
            <ProductItemParcels parcels={item.parcels} />
          </P2GGrid>
        </P2GGrid>
      }
      right={slots?.['product-item-extras']?.(item)}
      wrapper={(x) => x}
      dataTestId={`basket-item-${index}`}
    />
  );
}
